let searchHistory = window.localStorage.getItem('searchHistory')
try {
  searchHistory = JSON.parse(searchHistory) || []
} catch (error) {
  searchHistory = []
}

export default {
  namespaced: true,
  state: {
    searchHistory
  },

  mutations: {
    setSearchHistory(state, payload) {
      state.searchHistory = payload
    },
  },

  actions: {
    addSearchHistory({ commit, state }, payload) {
      if (!payload) return
      const has = state.searchHistory.find(item => item === payload)
      if (has) return

      const history = [...state.searchHistory, payload].slice(0, 20)
      window.localStorage.setItem('searchHistory', JSON.stringify(history))
      commit('setSearchHistory', history)
    },

    clearSearchHistory({ commit }) {
      window.localStorage.removeItem('searchHistory')
      commit('setSearchHistory', [])
    }
  }
}

